import "./BodyLoading.css";

function BodyLoading() {
  return (
    <section id="case-body" className="body-loading-section">
      <div className="case-body-container body-loading-container">
        <div className="shimmer body-skeleton-line" style={{ width: "100%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "85%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "92%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "60%" }} />
        <div className="shimmer body-skeleton-image" />
        <div className="shimmer body-skeleton-line" style={{ width: "100%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "78%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "88%" }} />
        <div className="shimmer body-skeleton-line" style={{ width: "50%" }} />
      </div>
    </section>
  );
}

export default BodyLoading;
